<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx Form__tx--mt_sm">
            「退会する」ボタンを押すとMELON ONLINEを退会します。
          </p>
          <div class="Form__checkbtn--mt_lg Form__btn_area">
            <label for="mail" class="Check__box _cl-01 _l-xlg"><input id="mail" v-model="is_received_mail_promotion" type="checkbox"><span class="Check__box_inner" />今後もマインドフルネスの情報・リアルクラス開催などのお知らせメールは受け取る</label>
          </div>
          <div v-if="isError" class="Form__tx Form__tx--mt_sm">
            <label class="Form__error_tx">通信エラーで退会処理が完了できませんでした。再度お試しください。</label>
          </div>
          <button class="Btn__blue _mg-t40 _back-cl04" @click="withdrawUser()">
            退会する
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
export default {
  name: 'Enquete',
  data() {
    return {
      is_received_mail_promotion: true,
      isError: false
    }
  },
  methods: {
    async withdrawUser() {
      this.$store.dispatch('loading/updateLoading', true)
      try {
        await authService.updateUserInfo({ is_received_mail_promotion: this.is_received_mail_promotion })
        authService.withdrawSystem().then((res) => {
          if (res && res.success) {
            this.isError = false
            this.$router.push({ name: 'UnsubscribeThanks' })
            window.open('https://docs.google.com/forms/d/e/1FAIpQLSegHww68oaaAGWHregKjKZcpIq4MBv0uYMFy0fquTgsEYBqwA/viewform')
          } else {
            this.isError = true
          }
        })
      } catch (e) {
        console.error(e)
        this.isError = true
      } finally {
        this.$store.dispatch('loading/updateLoading', false)
      }
    }
  }
}
</script>
